import React from 'react';
import { connect } from 'react-redux';

import type { RootState } from '@swf/core/store';
import { select } from '@swf/core/store';

type StateProps = ReturnType<typeof mapState>;

export type Props = StateProps;

const ChestCount: React.FC<Props> = ({ availableCount = 0 }) => <span>{availableCount}</span>;

const mapState = (rootState: RootState) => ({
  availableCount: select.chestInventory.get(rootState).availableCount
});

export default connect(mapState)(ChestCount);
